import authentication from '@/middleware/authentication'
import store from '@/store'
import axios from 'axios'
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'welcome',
    component: function () {
      return import('@/views/Welcome.vue')
    }
  },
  {
    path: '/register',
    name: 'register',
    component: function () {
      return import('@/views/Register.vue')
    }
  },
  {
    path: '/login',
    name: 'login',
    component: function () {
      return import('@/views/Login.vue')
    }
  },
  {
    path: '/news',
    name: 'news',
    component: function () {
      return import('@/views/News.vue')
    }
  },
  {
    path: '/home',
    name: 'home',
    component: function () {
      return import('@/views/HomeView.vue')
    }
  },
  {
    path: '/recommend',
    name: 'recommend',
    component: function () {
      return import('@/views/Recomend.vue')
    }
  },
  {
    path: '/bonus',
    name: 'bonus',
    component: function () {
      return import('@/views/Bonus.vue')
    }
  },
  {
    path: '/chit',
    name: 'chit',
    component: function () {
      return import('@/views/Chit.vue')
    }
  },
  {
    path: '/bet',
    name: 'bet',
    component: function () {
      return import('@/views/BetView.vue')
    }
  },
  {
    path: '/bet/group',
    name: 'bet_group',
    component: function () {
      return import('@/components/bet_component.vue')
    }
  },
  {
    path: '/bet/lottery',
    name: 'bet_lottery',
    component: function () {
      return import('@/components/lottery_component.vue')
    }
  },
  {
    path: '/topup',
    name: 'topup',
    component: function () {
      return import('@/views/TopupView.vue')
    }
  },
  {
    path: '/with_draw',
    name: 'with_draw',
    component: function () {
      return import('@/views/WithDraw.vue')
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: function () {
      return import('@/views/ProfileView.vue')
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.name !== 'welcome' && to.name !== 'register') {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_SERVER}/user/auth/profile`,
        authentication.getHeaderAuthen()
      );

      if (response.data.success) {
        store.commit('setProfileState', response.data.obj)
        return next(); // Proceed normally if authenticated
      } else {
        // localStorage.removeItem('auth');
        // localStorage.removeItem('refresh');
        // return next('/login'); // Redirect to login
      }
    } catch (error) {
      // console.log(error.response);
      if (error.response && error.response.status === 401) {
        const refreshToken = localStorage.getItem("refresh");
        await axios.post(`${process.env.VUE_APP_SERVER}/user/auth/refresh-token`, {
          "refreshToken": refreshToken,
        }).then(responseRefersh => {
          if (responseRefersh.data.success) {
            localStorage.setItem("auth", responseRefersh.data.obj.access_token);
            localStorage.setItem("refresh", responseRefersh.data.obj.refresh_token);
          } else {
            localStorage.removeItem('auth');
            localStorage.removeItem('refresh');

            if (to.name !== 'login') {
              return next('/login');
            }
          }
        })
        // if (to.name !== 'login') {
        //   return next('/login');
        // }
      }
    }
  }
  next(); // Proceed if no conditions matched
});


// router.beforeEach((to, from, next) => {
//   if (to.name !== 'welcome') {
//     axios.get(`${process.env.VUE_APP_SERVER}/user/auth/profile`, authentication.getHeaderAuthen()).then(response => {
//       if (response.data.success) {
//         // localStorage.setItem('id', JSON.stringify(response.data.id));
//       } else {
//         localStorage.removeItem('auth');
//         // location.href = '/';
//       }
//     })
//       .catch(error => {
//         console.log(error.response)
//         if (error.response.status === 401) {
//           localStorage.removeItem('auth');
//           return next('/login');
//           // location.href = '/login';
//         }
//       })
//   }

//   return next();
// });


export default router
